<template>
  <b-container fluid class="main-wrapper">
    <b-card
      class="mt-5"
      style="
        width: 350px;
        display: table;
        margin-right: auto;
        margin-left: auto;
      "
    >
      <div class="text-center m-3">
        <b-img
          fluid
          alt="Email Confirmation"
          :src="icon"
          style="width: 128px"
        />
      </div>
      <ValidationObserver v-if="validCode && !succeed" v-slot="{ passes }">
        <b-input-group sm="12" class="mt-3">
          <b-form-input
            rules="required|min:6|custompassword"
            :type="showPassword ? 'text' : 'password'"
            icon="lock"
            name="Password"
            v-model="password"
            placeholder="Password"
            v-b-tooltip.focus.top="{
              title:
                'Password minimal 6 (enam) karakter yang terdiri dari huruf dan angka',
              variant: 'info',
            }"
          />
          <b-input-group-append>
            <b-button
              @click="showPassword = !showPassword"
              variant="success"
              class="w-100"
            >
              <b-icon
                :icon="showPassword ? 'eye-slash-fill' : 'eye-fill'"
              ></b-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <b-input-group sm="12" class="my-3">
              <b-form-input
                rules="required|confirmed:password|min:6|custompassword"
                :type="showConfirmationPassword ? 'text' : 'password'"
                icon="lock"
                name="Password"
                v-model="passwordConfirmation"
                placeholder="Isikan kembali Password"
                v-b-tooltip.focus.top="{
                title:
                  'Password minimal 6 (enam) karakter yang terdiri dari huruf dan angka',
                variant: 'info',
              }"
              />
              <b-input-group-append>
                <b-button
                  @click="showConfirmationPassword = !showConfirmationPassword"
                  variant="success"
                  class="w-100"
                >
                  <b-icon
                    :icon="showConfirmationPassword ? 'eye-slash-fill' : 'eye-fill'"
                  ></b-icon>
                </b-button>
              </b-input-group-append>
            </b-input-group>
        <div>
          <b-button
            type="submit"
            variant="primary"
            size="sm"
            class="float-right mb-3"
            @click="passes(changePassword)"
          >
            Simpan
          </b-button>
        </div>
      </ValidationObserver>
      <div v-else>
        <legend class="text-center" :style="style">
          {{ header }}
        </legend>
        <p class="text-center" style="font-weight: 400">
          {{ subheader }}
        </p>
        <b-button
          v-if="succeed"
          type="link"
          variant="outline-primary"
          size="sm"
          class="float-right mb-3"
          @click="$router.push('/pmse')"
        >
          Ke halaman login
        </b-button>
      </div>
    </b-card>
  </b-container>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import swal from "sweetalert2";
import PmseService from "../../../services/PmseService";

export default {
  name: "ResetPasswordPmse",
  components: { ValidationObserver, },
  data: () => {
    return {
      icon: "../img/change-password-45.svg",
      style: "font-weight: 500; color: #09cc9a",
      validCode: null,
      succeed: false,
      password: "",
      passwordConfirmation: "",
      showPassword: false,
      showConfirmationPassword: false,
    };
  },
  mounted() {
    this.verifikasi(this.$route.params.code);
  },
  methods: {
    async verifikasi(code) {
      await PmseService.verifyForgotPassword(code).then(
        () => {
          // console.log(result.data);
          this.validCode = true;
        },
        (error) => {
          if (error.response) {
            this.icon = "../img/mail_confirmation_invalid.svg";
            this.style = "font-weight: 500; color: #ff6884";
            this.header = "Kode Tidak Valid";
            this.subheader =
              "Mohon maaf, kode reset password tidak valid pastikan melakukan reset password melalui tautan yang dikirimkan ke alamat email yang digunakan saat melakukan reset password.";
            this.validCode = false;
          }
        }
      );
    },
    changePassword() {
      swal
        .fire({
          title: "Apakah yakin ingin menggunakan password ini ?",
          // text: "Pengguna yang dihapus tidak dapat dipulihkan kembali",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ya",
        })
        .then((result) => {
          if (result.isConfirmed) {
            swal.fire({
              title: "Mohon Tunggu !",
              html: "Processing...",
              icon: "info",
              allowOutsideClick: false,
              showConfirmButton: false,
              onBeforeOpen: () => {
                swal.showLoading();
              },
            });
            let data = {
              password: this.password,
              passwordConfirmation: this.passwordConfirmation,
              verificationCode: this.$route.params.code,
            };
            PmseService.resetPassword(data).then(
              () => {
                swal.close();
                this.notif(
                  "Berhasil!",
                  "Password Berhasil diubah !",
                  "success"
                );
                this.header = "Password anda telah berhasil diubah!";
                this.subheader = "Silakan pergi ke halaman login!";
                this.succeed = true;
              },
              (error) => {
                swal.close();
                this.notif(
                  "Terdapat kesalahan!",
                  error.response.data.message,
                  "error"
                );
              }
            );
          }
        });
    },
    notif(title, content, type) {
      swal.fire(title, content, type);
    },
  },
};
</script>
